function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--theme-border);\n  background-color: var(--my-post-background); /* 변경된 변수 이름 사용 */\n  color: var(--theme-text); /* fallback 제거 */\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  \n  &:last-child {\n    border-bottom: 0;\n  }\n  \n  ",
        "\n  \n  &:hover {\n    background-color: var(--theme-hover-bg); /* CSS 변수 사용, theme.isDark 제거 */\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-color: transparent;\n  transition: background-color 0.2s ease;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  margin: -0.75rem -1rem;\n  padding: 0.75rem 1rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        '\n  position: relative;\n  width: 100%;\n  z-index: 5;\n  \n  .poll-container {\n    position: relative;\n    z-index: 10;\n    pointer-events: all !important;\n    \n    /* 투표 옵션에도 명시적으로 클릭 이벤트 허용 */\n    .poll-component,\n    .poll-component > div,\n    .poll-component div[role="button"] {\n      pointer-events: all !important;\n      position: relative;\n      z-index: 15;\n    }\n  }\n'
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  border: 1px solid var(--theme-border); /* fallback 제거 */\n  border-radius: 0.75rem;\n  background-color: var(--my-post-background); /* 변경된 변수 이름 사용 */\n  color: var(--theme-text); /* fallback 제거 */\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  min-width: 0; /* 오버플로우 방지 */\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-weight: 700;\n  font-size: 0.875rem;\n  color: var(--theme-text); /* fallback 제거 */\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  color: #3b82f6;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.25rem;\n  font-size: 0.875rem;\n  white-space: pre-wrap;\n  color: var(--theme-text); /* fallback 제거 */\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: 2px;\n  background-color: var(--theme-border); /* fallback 제거 */\n  left: 1.5rem;\n  z-index: 1;\n  \n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  z-index: 2;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem;\n  border-radius: 9999px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  \n  &:hover {\n    background-color: var(--theme-hover-light); /* CSS 변수 사용, theme.isDark 제거 */\n    color: var(--theme-primary); /* fallback 제거 */\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n  \n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0.75rem;\n  padding-top: 0.25rem;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n  \n  a {\n    color: var(--theme-primary); /* fallback 제거 */\n    text-decoration: none;\n    \n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--theme-border); /* fallback 제거 */\n  font-size: 0.75rem;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  padding: 0.25rem;\n  border-radius: 9999px;\n  transition: background-color 0.2s ease;\n  color: var(--theme-text-secondary); /* fallback 제거 */\n  \n  &:hover {\n    background-color: var(--theme-hover-light); /* CSS 변수 사용, theme.isDark 제거 */\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  text-decoration: none;\n  color: inherit;\n  display: block;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// Theme import는 더 이상 필요하지 않을 수 있습니다. (만약 다른 곳에서 사용하지 않는다면)
// import { Theme } from '../../../styles/theme'; 
import { Link } from 'react-router';
// Force rebuild at 19:25:00
// 소셜 포스트 컨테이너
export var PostContainer = styled.div(_templateObject(), function(param) {
    var $isDetailView = param.$isDetailView;
    return $isDetailView && "\n    padding: 0.75rem 1rem;\n    border-bottom: none;\n  ";
});
// 호버 효과를 위한 배경 레이어
export var HoverBackground = styled.div(_templateObject1());
// 게시물 내용 래퍼
export var PostWrapper = styled.div(_templateObject2());
// 컨텐츠 컨테이너 (스레드 라인용 여백 포함)
export var ContentContainer = styled.div(_templateObject3(), function(param) {
    var $hasThreadLine = param.$hasThreadLine;
    return $hasThreadLine && "\n    padding-left: 2.5rem;\n    margin-left: 0.25rem;\n  ";
});
// 컨텐츠 영역
export var ContentWrapper = styled.div(_templateObject4());
// 컴팩트 모드 포스트
export var CompactPostContainer = styled.div(_templateObject5());
// 컴팩트 모드 컨텐츠 래퍼
export var CompactContentWrapper = styled.div(_templateObject6());
// 컴팩트 모드 헤더
export var CompactHeader = styled.div(_templateObject7());
// 사용자 이름
export var UserName = styled.span(_templateObject8());
// 인증 마크
export var VerifiedBadge = styled.span(_templateObject9());
// 사용자 아이디
export var UserID = styled.span(_templateObject10());
// 타임스탬프
export var Timestamp = styled.span(_templateObject11());
// 컨텐츠 텍스트
export var ContentText = styled.p(_templateObject12());
// 미디어 컨테이너
export var MediaContainer = styled.div(_templateObject13());
// 스레드 라인
export var ThreadLine = styled.div(_templateObject14(), function(param) {
    var isTop = param.isTop;
    return isTop && "\n    top: 0;\n    height: 50%;\n  ";
}, function(param) {
    var isBottom = param.isBottom;
    return isBottom && "\n    bottom: 0;\n    height: 50%;\n  ";
});
// 아바타 컨테이너
export var AvatarContainer = styled.div(_templateObject15());
// 액션 버튼
export var ActionButton = styled.button(_templateObject16(), function(param) {
    var isActive = param.isActive;
    return isActive && " \n    color: var(--theme-primary); /* fallback 제거 */\n  ";
});
// 액션 카운트
export var ActionCount = styled.span(_templateObject17(), function(param) {
    var isActive = param.isActive;
    return isActive && "\n    color: var(--theme-primary); /* fallback 제거 */\n  ";
});
// 액션 버튼 그룹
export var ActionButtonGroup = styled.div(_templateObject18());
// 리트윗 헤더
export var RetweetHeader = styled.div(_templateObject19());
// 답글 정보
export var ReplyInfo = styled.div(_templateObject20());
// 게시물 푸터
export var PostFooter = styled.div(_templateObject21());
// 더보기 버튼
export var MoreButton = styled.button(_templateObject22());
// 게시물 링크
export var PostLink = styled(Link)(_templateObject23());
